// extracted by mini-css-extract-plugin
export var colorTexto = "dropDownSmart-module--colorTexto--94816";
export var container = "dropDownSmart-module--container--096f4";
export var container__child = "dropDownSmart-module--container__child--78f09";
export var dropdown = "dropDownSmart-module--dropdown--3422f";
export var dropdown__content = "dropDownSmart-module--dropdown__content--b0b75";
export var names = "dropDownSmart-module--names--40e96";
export var open = "dropDownSmart-module--open--3e00a";
export var rotate = "dropDownSmart-module--rotate--2e93d";
export var rotate2 = "dropDownSmart-module--rotate2--4d447";
export var rotate3 = "dropDownSmart-module--rotate3--5376a";
export var rotate4 = "dropDownSmart-module--rotate4--cfef8";
export var section__container = "dropDownSmart-module--section__container--19e19";
export var space__button = "dropDownSmart-module--space__button--90a5e";
export var texto = "dropDownSmart-module--texto--9a460";
export var title = "dropDownSmart-module--title--bf685";
export var title__container__children = "dropDownSmart-module--title__container__children--ae87a";